import { Col, Container, Row, Table, Button, ButtonGroup, Form } from "react-bootstrap";
import { Loader } from "../../components/loader";
import { TitleWithBackButton } from "../../components/title-with-back-button/titleWithBackButton";
import { useRecoilValue } from "recoil";
import { userState } from "../../utils/atom";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getRequest } from "../../utils/apiRequest";
import { formatDateTimeToDDMMYY, formatLocalTimeToHHMM } from "../../utils/formatDateTime";

const logTypes = [
    'admin', 'child', 'course', 'enrollment', 'invoice', 'mail', 'membercard', 'payment',
    'statistics', 'subscription', 'system', 'user', 'waiting-room'
];

const logLevels = ['info', 'warning', 'error'];

export const LoggingPage = () => {
    const [page, setPage] = useState(1);
    const [amount, setAmount] = useState(10);
    const [logType, setLogType] = useState("");
    const [logLevel, setLogLevel] = useState("");
    const [logDate, setLogDate] = useState("");

    const { token } = useRecoilValue(userState);

    const queryParams = new URLSearchParams({
        page: page.toString(),
        amount: amount.toString(),
        ...(logType && { type: logType }),
        ...(logLevel && { level: logLevel }),
        ...(logDate && { date: logDate }),
    });

    const logQuery = useQuery({
        queryKey: ["log-query", page, amount, logType, logLevel, logDate],
        queryFn: () => getRequest(`/auth/logs?${queryParams.toString()}`, token),
        refetchOnWindowFocus: false,
    });

    const { data: logData } = logQuery;

    return (
        <Loader isActive={logQuery.isFetching || logQuery.isLoading}>
            {logData && (
                <>
                    <Container fluid className="mb-0">
                        <TitleWithBackButton title={"Logs"} />
                    </Container>
                    <Container className="pb-3">
                        <Row className="mb-3 mt-3 gap-3">
                            <Col md={3}>
                                <Form.Label>Log-Typ</Form.Label>
                                <Form.Select
                                    value={logType}
                                    onChange={(e) => {
                                        setLogType(e.target.value);
                                        setPage(1);
                                    }}
                                >
                                    <option value="">Alle</option>
                                    {logTypes.map((type) => (
                                        <option key={type} value={type}>
                                            {type}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md={3}>
                                <Form.Label>Log-Level</Form.Label>
                                <Form.Select
                                    value={logLevel}
                                    onChange={(e) => {
                                        setLogLevel(e.target.value);
                                        setPage(1);
                                    }}
                                >
                                    <option value="">Alle</option>
                                    {logLevels.map((level) => (
                                        <option key={level} value={level}>
                                            {level}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md={3}>
                                <Form.Label>Datum</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={logDate}
                                    onChange={(e) => {
                                        setLogDate(e.target.value);
                                        setPage(1);
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12}>
                                <Table striped bordered hover responsive className="mt-3">
                                    <thead>
                                        <tr>
                                            <th className="text-center">Uhrzeit</th>
                                            <th className="text-center">Level</th>
                                            <th className="text-center">Modul</th>
                                            <th>Message</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {logData.data.map((log, index) => (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    {formatDateTimeToDDMMYY(log.createdAt)} |{" "}
                                                    {formatLocalTimeToHHMM(log.createdAt, true, true)}
                                                </td>
                                                <td className={`text-${log.level === "error" ? "danger" : log.level} text-center`}>
                                                    {log.level}
                                                </td>
                                                <td className="text-center">{log.type}</td>
                                                <td>{log.message}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <div className="d-flex align-items-center gap-2">
                                        <label htmlFor="amount-select" className="mb-0">
                                            Einträge:
                                        </label>
                                        <select
                                            id="amount-select"
                                            value={amount}
                                            onChange={(e) => {
                                                setAmount(Number(e.target.value));
                                                setPage(1);
                                            }}
                                            className="form-select form-select-sm"
                                            style={{ width: "auto" }}
                                        >
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={50}>50</option>
                                        </select>
                                    </div>
                                    <span>Seite {page}</span>
                                    <ButtonGroup>
                                        <Button
                                            variant="secondary"
                                            disabled={page === 1}
                                            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                                        >
                                            Zurück
                                        </Button>
                                        <Button
                                            variant="secondary"
                                            disabled={!logData?.data?.length || logData.data.length < amount}
                                            onClick={() => setPage((prev) => prev + 1)}
                                        >
                                            Weiter
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </>
            )}
        </Loader>
    );
};
